import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    position: absolute;
    width: ${displayState?.size ? `${displayState.size}px` : '24px'};
    height: ${displayState?.size ? `${displayState.size}px` : '24px'};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${displayState?.background ?? '#E3E3E3'};
    cursor: pointer;
    left: ${displayState?.size ? `-${displayState.size / 2}px` : '-12px'};
    top: 34px;
    z-index: 10;
  `}
`;

export default Atom({ type: 'button', dataType: 'object', template });